export default {
	setWhyEdim(state, why_edim) {
		state.why_edim = why_edim
	},
}
